export function applySystemZoom(systemZoomFactor?: number): void {
  if (typeof document === 'undefined') {
    return;
  }

  const factor = systemZoomFactor ?? 100;
  const scale = factor / 100;
  const html = document.documentElement;
  const body = document.body;

  html.style.setProperty('--systemZoom', String(scale));

  html.classList.remove('zoom-fallback');
  body.style.removeProperty('zoom');
}
